import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CustomSelect from "./CustomSelect.jsx";

const formatCategoryLabel = (category) => {
  if (!category || category === "all") return "All Categories";
  return category
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const CategoryNav = ({ categories = [], selectedCategory = "all" }) => {
  const navigate = useNavigate();

  const options = useMemo(() => {
    const unique = Array.from(new Set(categories.filter(Boolean)));
    return ["all", ...unique].map((cat) => ({
      value: cat,
      label: formatCategoryLabel(cat),
    }));
  }, [categories]);

  const handleChange = (category) => {
    if (!category || category === "all") {
      navigate("/");
    } else {
      navigate(`/category/${encodeURIComponent(category)}`);
    }
  };

  return (
    <nav className="border-t border-white/5 bg-slate-950/80">
      <div className="mx-auto max-w-6xl px-4 py-3">
        <div className="w-full sm:w-56">
          <CustomSelect
            value={selectedCategory}
            onChange={handleChange}
            options={options}
            placeholder="All Categories"
            variant="pill"
          />
        </div>
      </div>
    </nav>
  );
};

export default CategoryNav;
